import addDays from '@stencil/date-utils/src/addDays';

import parseUrlDateString from './date-utils/parse-url-date-string';

// UTILS
import {
  get_queryParameters,
  getAppliedFiltersUniFormatDecoder,
  getNewCheckInCheckOutDate,
  getSearchType,
  isAltAccoUrlParams,
  safeDecodeURIComponent,
} from './common-utils';
import {getEncodedDatesFromUrl} from './date-utils/date-utils';

// TYPE GUARDS
import {isDefined} from '@stencil/type-guards';

// TYPES
// have to extract types out into separate module to avoid circular dependency

// const { ICheckinCheckoutDate } = commonHotelsReduxTypes
// CONFIG
import {appConfig} from '@stencil/hotels-config';

const {defaultRoomString, defaultCheckinOffsetSeo, defaultCheckoutOffsetSeo} = appConfig;

export default function parseDetailsPageUrlToConfig(url, params) {
  const {hotelNameSlug = '', hotelId = '', cityName = ''} = params;
  const hotelName = hotelNameSlug.replace(/[^\w\s]/gi, ' ');
  const hc = hotelId;
  const hn = hotelName;
  const locus = {};

  // removed once the getParams changes are done
  let hquery = get_queryParameters('hquery', url) || '';
  const hctx = get_queryParameters('hctx', url);
  const sctx = get_queryParameters('sctx', url);
  const hmd = get_queryParameters('hmd', url);
  const vnd = get_queryParameters('vnd', url);
  const offerCodeFromQueryParam = get_queryParameters('offerCode', url);
  const metaPartner = get_queryParameters('metaTraffic', url);
  const country = get_queryParameters('cc', url);
  const subVendors = get_queryParameters('ev', url);
  const reviewType = get_queryParameters('reviewType', url);
  const vcid = get_queryParameters('vcid', url);
  const mmtId = get_queryParameters('mmtId', url);
  const topHtlId = get_queryParameters('topHtlId', url);
  const giHotelId = get_queryParameters('giHotelId', url);
  const fcSlotId = get_queryParameters('fcSlotId', url);
  const isSEO = get_queryParameters('isSEO', url);
  if (get_queryParameters('locusId', url)) {
    locus.id = get_queryParameters('locusId', url);
  }
  if (get_queryParameters('locusType', url)) {
    locus.type = get_queryParameters('locusType', url);
  }
  if (get_queryParameters('cityCode', url)) {
    locus.cityCode = get_queryParameters('cityCode', url);
  }
  const appliedFiltersQueryParam = safeDecodeURIComponent(
    get_queryParameters('appliedFilters', url),
  );
  const appliedFilters = JSON.parse(appliedFiltersQueryParam);

  let appliedCgFilters = getAppliedFiltersUniFormatDecoder(
    safeDecodeURIComponent(get_queryParameters('appliedFiltersUniFormat', url)),
  );

  const newFilterData = get_queryParameters('filterData', url) || '';
  const newLocationData = get_queryParameters('locationData', url) || '';
  const sortData = get_queryParameters('sort', url) || '';
  const unifFilterData = get_queryParameters('unifFilterData', url) || '';
  const altAcco = isAltAccoUrlParams(url);
  const sType =
    get_queryParameters('sType', url) ||
    getSearchType({
      locusType: locus.type,
      topHtlId: topHtlId,
      newLocationData,
      isSEO,
      mmtId,
    });

  const srpContinuedFilters = safeDecodeURIComponent(get_queryParameters('srpFilters', url));

  let {
    defaultCheckin: {date: defaultCheckinDate} = {},
    defaultCheckout: {date: defaultCheckoutDate} = {},
  } = getNewCheckInCheckOutDate(defaultCheckinOffsetSeo, defaultCheckoutOffsetSeo, true);

  let checkin: ICheckinCheckoutDate = {date: defaultCheckinDate};
  let checkout: ICheckinCheckoutDate = {date: defaultCheckoutDate};

  let roomString: string = defaultRoomString;
  let ibp: string = '';

  if (get_queryParameters('checkin', url) && get_queryParameters('checkout', url)) {
    const urlParamCheckin = get_queryParameters('checkin', url);
    const urlParamCheckout = get_queryParameters('checkout', url);
    const {checkInDate, checkOutDate} = getEncodedDatesFromUrl({
      ci: urlParamCheckin,
      co: urlParamCheckout,
    });
    checkin.date = checkInDate;
    checkout.date = checkOutDate;
    roomString = get_queryParameters('roomString', url) || defaultRoomString;
  } else if (isDefined(hquery) && hquery.length > 0) {
    try {
      let {
        ci = '',
        co = '',
        r = defaultRoomString,
        ld = '',
        ibp: hqueryIbp = '',
      } = JSON.parse(decodeURIComponent(hquery));

      // Check if the ci or co contains 'date_'
      const dates = getEncodedDatesFromUrl({ci, co});
      checkin.date = dates.checkInDate;
      checkout.date = dates.checkOutDate;

      ibp = hqueryIbp ? hqueryIbp : '';

      roomString = r ? r : defaultRoomString;
    } catch (err) {
      // ! must allow flow to continue even after error with defaults, if possible
      console.error(err);
    }
  }

  let filter = {};

  // ! when are the following filled ?
  if (hctx) {
    filter = {hctx};
  }

  if (sctx) {
    filter = {
      ...filter,
      sctx: sctx.split(','),
    };
  }

  return {
    vhid: hc,
    cityName,
    roomString,
    ibp,
    metaPartner,
    filter,
    checkin,
    checkout,
    offerCodeFromQueryParam,
    appliedFilters,
    appliedFiltersInUrl: appliedCgFilters,
    hotelId: hc || giHotelId,
    hmd,
    country,
    subVendors,
    vnd,
    selectedHotelStatic: {
      hn,
      hc,
      ibp,
      hmd,
      reviewType,
      vcid,
      srpContinuedFilters,
    },
    mmtId,
    topHtlId,
    sType,
    locus,
    newFilterData,
    newLocationData,
    sortData,
    unifFilterData,
    altAcco,
    fcSlotId,
  };
}
